<template>
    <!-- 这一坨是课程目录 -->
      <div class="row">
        <div class="col-12">
            <img src="../../assets/kcimg/catalogue-title.png" alt="" width="120px" style="margin-bottom: 20px;">
            <div class="row" style="padding-top: 10px;">
                <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item" v-for="(item, index) in catalog" :key="index">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                            :data-bs-target="'#c' + item.id" aria-expanded="false" 
                            :aria-controls="'c' + item.id" style="font-size: 17px;">
                                {{ item.title }}
                            </button>
                        </h2>
                        <div :id="'c' + item.id" class="accordion-collapse collapse">
                            <div class="accordion-body" style="font-size: 14px;">
                                <div class="row">
                                    <div class="col-12" style="font-size: 14px;">
                                        {{ item.content }} ———— <code class="hover" @click="ToVideo(item.id, index)">相关课程</code>
                                    </div>
                                    <div class="col-12"><hr></div>
                                    <div class="col-11" style="font-size: 14px; margin: 5px auto;">
                                        <CatalogProlbem v-if="isOpen" :cId="item.id"></CatalogProlbem>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
</template>

<script>
    import Url from "@/constant/Url"
    import $ from "jquery"
    import CatalogProlbem from './CatalogProblem.vue'
    export default {
        name:'Catalog',
        components: {
            CatalogProlbem
        },
        props:["videoInfo"],
        data() {
            return {
                isOpen:false,
                visible: false, // 打开弹窗用的
                activeNames: [], // 这个是目录

                catalog:[],

                courseId: '',
                title: '',
                content: '',
                number: '',
                
                error_message:'',
                courseVideo:[],
            }
        },
        mounted() {
            console.log("videoInfo", this.videoInfo)
            this.GetCatalog()
        },
        methods: {
            ToVideo(id, index) {
                if (index > 0 && this.videoInfo.id === undefined) { // 则需要判断一下能不能过去
                    this.$message({
                        message: '未购买该课程，视频暂不可看',
                        type: 'warning'
                    });
                    return ;
                }

                console.log("目录id", id)
                const vue = this
                const store = this.$store
                const router = this.$router
                const route = this.$route
                console.log("params == >", route.params.id)
                $.ajax({
                    url: Url.rCourseVideoUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        catalogId: id, // 目录id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.courseVideo = JSON.parse(resp.list)
                            console.log("list == >", vue.courseVideo)
                            router.push({
                                path:`/programmes/videoing/${route.params.id}/${id}/${vue.courseVideo[0].id}`,
                                params: {
                                    id: route.params.id,
                                    catalogId: id,
                                    Vid: vue.courseVideo[0].id,
                                }
                            })
                        }
                    },
                    error(resp) {
                        console.log("获取课程视频彻底失败了, resp == >", resp)
                    }
                })
            },
            handleChange(val) {
                console.log(val);
            },
            openUpdate(item) {
                this.title = item.title
                this.content = item.content
                this.number = item.number
                // this.UpdateCatalog(item.id)
            },
            GetCatalog() { // 获取所有目录 
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalog/read/list/',
                    type:'post',
                    data: {
                        courseId: route.params.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("获取目录成功了")
                            vue.catalog = JSON.parse(resp.List)
                            vue.isOpen = true
                            // console.log(vue.catalog)
                        } else {
                            console.log("获取目录失败了")
                        }
                    },
                    error(resp) {
                        console.log("获取目录彻底失败了, resp == >", resp)
                    }
                })
            },
        }
    }
</script>

<style scoped>
.hh:hover {
    cursor: pointer;
    color: green;
}
.hover {
    font-size: 14px; cursor: pointer;
}
.hover:hover {
    color: pink;
}
</style>